<template>
    <div>
        <template v-if="isAuthorized">
            <v-row no-gutters class="my-3 justify-center">
                <v-col cols="2">
                    <!-- <template v-if="!accountableAccountsSelected.length"> -->
                    <v-btn-primary
                        @click="openAccountingItemEdition(false)"
                        block
                        data-cy="accountingLogDocument-add"
                        >Ajouter</v-btn-primary
                    >
                    <!-- </template>
                <template v-else>
                    <v-btn

                        color="secondary"
                        elevation="0"
                        block
                        height="40px"
                        class="rounded-lg gradient"
                        :disabled="!accountableAccountsSelected.length"
                        @click="exportDialog = true"
                    >Exporter</v-btn>
                </template> -->
                </v-col>
                <v-col :cols="$vuetify.display.mobile ? '12' : '6'" class="pl-2">
                    <oss-filter-bar
                        :mode="'document'"
                        v-model:type="type"
                        :showTypeTag="false"
                        v-model:text="search"
                        v-model:tags="documentTags"
                        v-model:startDate="beginDate"
                        v-model:endDate="endDate"
                        :minDate="minDate"
                        :maxDate="maxDate"
                        v-model:status="documentStatus"
                        :showStatusTag="false"
                        :statusIsManadatory="true"
                        :dateIsManadatory="true"
                        v-model:thirdPartyCompanyName="thirdPartyCompanyName"
                        :minPrice="minAmount"
                        @update:minPrice="
                            documentType === 'PURCHASE_INVOICE'
                                ? (maxAmount = -$event + '')
                                : (minAmount = $event + '')
                        "
                        :maxPrice="maxAmount"
                        @update:maxPrice="
                            documentType === 'PURCHASE_INVOICE'
                                ? (minAmount = -$event + '')
                                : (maxAmount = $event + '')
                        "
                        :limitMinPrice="
                            documentType === 'PURCHASE_INVOICE'
                                ? -maxDocumentAmount
                                : minDocumentAmount
                        "
                        :limitMaxPrice="
                            documentType === 'PURCHASE_INVOICE'
                                ? -minDocumentAmount
                                : maxDocumentAmount
                        "
                        :types-list="
                            logTypes.map((type) => {
                                return { value: type, text: formatType(type) };
                            })
                        "
                        :status-list="
                            allDocumentStatus.map((type) => {
                                return { value: type, text: formatStatus(type) };
                            })
                        "
                        :companyId="selectedCompany.id"
                        data-cy="AccountingLogDocument-filter"
                    />
                </v-col>
                <v-col cols="2" class="pl-2">
                    <v-text-field
                        outlined
                        readonly
                        :model-value="'Débit : ' + newCommonFormatCurrency(totalDebit)"
                        density="compact"
                    >
                    </v-text-field>
                </v-col>
                <v-col cols="2" class="pl-2">
                    <v-text-field
                        outlined
                        readonly
                        :model-value="'Crédit : ' + newCommonFormatCurrency(totalCredit)"
                        density="compact"
                    >
                    </v-text-field>
                </v-col>
            </v-row>
            <v-data-table-server
                :headers="headers"
                :items="documents"
                :page="pagination.page"
                :sort-by="pagination.sortBy"
                :sort-desc="pagination.descending"
                :items-per-page="pagination.rowsPerPage"
                :items-length="pagination.totalItems"
                :items-per-page-options="[5, 10, 25]"
                :loading="loading"
                class="table"
                hide-default-footer
                fixed-header
                height="75vh"
                style="min-width: 1150px"
                v-if="documentType !== 'MAIL'"
                density="compact"
            >
                <template #headers="{ columns: headers }">
                    <tr>
                        <th :colspan="1" style="width: 64px">
                            <v-checkbox
                                v-model="isAllSelected"
                                :indeterminate="
                                    selectedDocumentIds.length > 0 &&
                                    selectedDocumentIds.length !== documents.length
                                "
                                color="primary"
                                density="compact"
                                hide-details
                            />
                        </th>
                        <th :colspan="headers.length" style="padding-left: 0">
                            <v-row no-gutters>
                                <v-col cols="4">
                                    <v-btn-ternary
                                        @click="openAccountingItemEdition(true)"
                                        :disabled="disabledReversal"
                                        class="mr-3"
                                    >
                                        Extourner
                                    </v-btn-ternary>
                                    <!-- <v-btn
                                        @click="dialogChangeThirdPartyCompanyDocument = true"
                                        rounded
                                        color="ternary"
                                        :disabled="!onlySalesSelected"
                                         size="small"
                                        elevation="0"
                                        class="mr-3"
                                        v-if="isAccountingUser"
                                    >
                                        Client
                                    </v-btn>
                                    <multiple-free-tagging
                                        :company="selectedCompany"
                                        :company-tags="allCompanyTags"
                                        :selected-documents="selectedDocuments"
                                        @selected-tags="onMultiTagguingApplied"
                                    ></multiple-free-tagging> -->
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ props }">
                                            <v-btn-icon icon="$dots_vertical" v-bind="props" />
                                        </template>
                                        <v-list>
                                            <!-- <v-list-item @click="showTag = !showTag">
                                                <v-list-item-title>{{
                                                    showTag
                                                        ? "Cacher les étiquettes"
                                                        : "Afficher les étiquettes"
                                                }}</v-list-item-title>
                                                <template #append>
                                                    <v-icon size="small">$oss-eye</v-icon>
                                                </template>
                                            </v-list-item>
                                            <v-list-item
                                                :disabled="disabledDownload"
                                                @click="startDownloadFile"
                                                v-if="isAccountingUser"
                                            >
                                                <v-list-item-title
                                                    >Télécharger</v-list-item-title
                                                >
                                                <template #append>
                                                    <v-icon size="small">$oss-download</v-icon>
                                                </template>
                                            </v-list-item>-->
                                            <v-list-item
                                                v-if="!displayDeletePermanentlyButton"
                                                :disabled="disabledDelete"
                                                color="error"
                                                @click="dialogDeleteSelectedDocument = true"
                                                :active="!disabledDelete"
                                            >
                                                <v-list-item-title>Supprimer</v-list-item-title>
                                                <template #append>
                                                    <v-icon size="small">$delete</v-icon>
                                                </template>
                                            </v-list-item>
                                            <v-list-item
                                                v-if="displayDeletePermanentlyButton"
                                                :disabled="disabledDeletePermanently"
                                                color="red"
                                                @click="
                                                    dialogDeletePermanentlySelectedDocument = true
                                                "
                                                :active="!disabledDeletePermanently"
                                            >
                                                <v-list-item-title
                                                    >Supprimer définitivement</v-list-item-title
                                                >
                                                <template #append>
                                                    <v-icon size="small">$delete</v-icon>
                                                </template>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                    <!-- <v-menu offset-y v-if="isAccountingUser">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            >
                                                <v-icon>$dots_vertical</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                :disabled="disabledDownload"
                                                @click="selectedDocumentIds.length === 1 ? dialogChooseDownload = true: downloadFile(true)"
                                            >
                                                <v-list-item-title>Télécharger</v-list-item-title>
                                                <template v-slot:append>
                                                    <v-icon  size="small">$oss-download</v-icon>
                                                </template>
                                            </v-list-item>
                                            <v-divider></v-divider>
                                            <v-list-item
                                                :disabled="disabledDelete"
                                                @click="dialogDeleteSelectedDocument = true"
                                            >
                                                <v-list-item-title>Supprimer</v-list-item-title>
                                                <template v-slot:append>
                                                    <v-icon  size="small">$delete</v-icon>
                                                </template>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu> -->
                                </v-col>
                                <v-spacer />
                                <v-col cols="5" class="d-flex justify-end align-center pb-1">
                                    <v-select
                                        v-model="sortBy"
                                        :items="sortByList"
                                        style="font-size: 0.75rem; width: min-content"
                                        hide-details
                                        item-value="key"
                                        width="30px"
                                        prefix="Trier par"
                                        outlined
                                        return-object
                                        density="compact"
                                        :item-title="(item) => item.text"
                                    />
                                    <v-select
                                        v-model="pagination.rowsPerPage"
                                        :items="[5, 10, 25]"
                                        hide-details
                                        outlined
                                        style="font-size: 0.75rem; width: min-content"
                                        width="30px"
                                        prefix="Lignes par page"
                                        density="compact"
                                    />
                                    <span style="white-space: nowrap">
                                        {{ (pagination.page - 1) * pagination.rowsPerPage + 1 }}
                                        -
                                        {{
                                            (pagination.page - 1) * pagination.rowsPerPage +
                                            pagination.rowsPerPage
                                        }}
                                        de {{ pagination.totalItems }}
                                    </span>
                                    <v-btn-prev
                                        @click="pagination.page--"
                                        :disabled="pagination.page === 1"
                                        size="small"
                                    />
                                    <v-btn-next
                                        @click="pagination.page++"
                                        size="small"
                                        :disabled="nextPageDisabled"
                                    />
                                </v-col>
                            </v-row>
                        </th>
                    </tr>
                </template>

                <template v-slot:no-data>Aucune écriture trouvée</template>
                <template v-slot:item="props">
                    <template
                        v-for="(al, index) in props.item.accountingLines"
                        :key="props.item.id + '_' + index"
                    >
                        <tr
                            style="cursor: pointer"
                            :data-cy="'AccountingLogDocument-document-' + index"
                            @click="openDocument(props.item)"
                        >
                            <td class="text-center" :style="getCellStyle(index, 'width: 64px;')">
                                <v-checkbox
                                    @click.stop="addSelectedDocument(props.item.id)"
                                    class="pa-0 ma-0"
                                    hide-details
                                    :ripple="false"
                                    v-if="index === 0"
                                    :model-value="isSelected(props.item.id)"
                                >
                                </v-checkbox>
                            </td>
                            <td
                                class="pl-2 pr-2 text-center"
                                :style="getCellStyle(index)"
                                v-if="documentType === 'ALL'"
                            >
                                <b v-if="index === 0">{{ getDocumentLog(props.item) }}</b>
                            </td>
                            <td class="px-0 text-center" :style="getCellStyle(index)">
                                {{ formatDate(al.date) }}
                            </td>
                            <td class="pl-2 pr-2 text-left" :style="getCellStyle(index)">
                                {{ getAccountableAccountTitle(al) }}
                            </td>
                            <td :style="getCellStyle(index)">
                                <v-chip
                                    label
                                    color="tagFree"
                                    class="mr-1"
                                    v-if="al.tag"
                                    size="x-small"
                                    >{{ al.tag.name }}</v-chip
                                >
                                <template v-if="al.tags">
                                    <v-chip
                                        label
                                        class="mr-1"
                                        v-for="(tag, tagIndex) in al.tags"
                                        :key="tagIndex"
                                        size="x-small"
                                        ><span :style="'color:' + labelTextColor + ';'">{{
                                            tag.name
                                        }}</span></v-chip
                                    >
                                </template>
                                {{ al.wording }}
                            </td>
                            <td :style="getCellStyle(index)">
                                {{ props.item.invoiceNumber || "" }}
                            </td>
                            <td class="text-left" :style="getCellStyle(index)">
                                {{ getThirdPartyName(al) }}
                            </td>
                            <td class="px-0 text-right" :style="getCellStyle(index)">
                                <span v-if="al.amountSigned > 0">{{
                                    newCommonFormatCurrency(Math.abs(al.amountSigned))
                                }}</span>
                            </td>
                            <td class="pl-0 pr-2 text-right" :style="getCellStyle(index)">
                                <span v-if="al.amountSigned < 0">{{
                                    newCommonFormatCurrency(Math.abs(al.amountSigned))
                                }}</span>
                            </td>
                        </tr>
                    </template>
                </template>
            </v-data-table-server>
            <oss-dialog
                v-model="accountingItemEditionDialog"
                :actions="actions"
                prefixDataCy="AccountingLogDocument"
                width="90vw"
            >
                <div>
                    <AccountingItemEdition2
                        v-if="accountingItemEditionDialog"
                        :inType="editionLog"
                        :inLogTagId="editionLogTagId"
                        :prefilledRows="prefilledRows"
                        :actions="actions"
                        :companyId="selectedCompany.id"
                        @upsert="
                            accountingItemEditionDialog = false;
                            refresh();
                        "
                    />
                </div>
            </oss-dialog>
            <oss-dialog
                v-model="dialogDeleteSelectedDocument"
                title="Supprimer des documents"
                validTitle="Oui, je suis sûr(e)"
                valid-class="error"
                @valid="deleteDocuments"
                width="800px"
            >
            <h4 class="text-center">
                Voulez-vous supprimer {{ selectedDocumentIds.length }} document{{
                    selectedDocumentIds.length === 1 ? "" : "s"
                }}
                ?
            </h4>
        </oss-dialog>
        </template>
    </div>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Documents } from "../document/Documents";
import OssFilterBar from "../ossComponents/ossFilterBar.vue";
import AccountingItemEdition2 from "../accounting/accountingItem/Edition.vue";
import MultipleFreeTagging from "../tag/MultipleFreeTagging.vue";

import { getUserDisplayName } from "../../services/userServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import DOCUMENTS_FILTER_QUERY from "../../graphql/document/FilterDocumentsLog.gql";
import colors from "vuetify/util/colors";
import { DialogAction } from "@/services/dialogAction";
import { getLastAccountingClosingEndDateFromStore } from "@/services/accountingPeriods";
import { Component, Model, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        OssFilterBar,
        AccountingItemEdition2,
        MultipleFreeTagging,
    },
})
export class AccountingLogDocument extends Documents {
    @Prop({ default: null }) documentTypes: any;
    @Prop({ default: null }) logTypes: any;
    // @Prop({ default: "ALL" }) value;

    /**
     * Represents the type of item to display.
     * AccountingLogPage needs to be informed when "BANK_TRANSACTION" is selected.
     * AccountingLogDocument needs to be informed when a document type is selected in AccountingLogBank.
     */
    @Model() value: string | undefined;

    editionLog = "";
    editionLogTagId = "";
    prefilledRows = [];

    accountingItemEditionDialog: boolean = false;

    actions = {
        action: new DialogAction(),
    };

    reversalDialog: boolean = false;

    get disabledReversal() {
        if (!this.selectedDocumentIds.length) {
            return true;
        }
        return false;
    }

    openAccountingItemEdition(reversal: boolean) {
        this.prefilledRows = [];
        this.editionLog = "";
        this.editionLogTagId = "";
        // identify editionLog and editionLogTagId
        if (this.documentType !== "ALL") {
            this.editionLog = this.documentType;
            this.editionLogTagId = this.logTagId;
        }
        let differentLogs: boolean = false;
        let differentLogTagIds: boolean = false;
        for (const docId of this.selectedDocumentIds) {
            debugger;
            const doc = this.documents.find((d) => d.id === docId);
            if (doc) {
                // identify editionLog and editionLogTagId
                if (!differentLogs) {
                    // DO NO CHANGE ORDER
                    if (!differentLogTagIds) {
                        let found: boolean = false;
                        for (const tag of doc.tags) {
                            if (tag.primaryLog) {
                                if (!this.editionLogTagId) {
                                    if (!this.editionLog) {
                                        this.editionLogTagId = tag.id;
                                    } else {
                                        differentLogTagIds = true;
                                    }
                                } else if (this.editionLogTagId !== tag.id) {
                                    differentLogTagIds = true;
                                }
                                found = true;
                                break;
                            }
                        }
                        if (!found && this.editionLogTagId) {
                            differentLogTagIds = true;
                        }
                    }
                    if (!this.editionLog) {
                        this.editionLog = doc.type;
                    } else if (this.editionLog != doc.type) {
                        differentLogs = true;
                    }
                }
                // compute best date taking into account accounting closing
                let mLastDate;
                let lastDate = getLastAccountingClosingEndDateFromStore(this.$store);
                if (lastDate) {
                    mLastDate = moment(lastDate).add(1, "day");
                    lastDate = mLastDate.format();
                }
                // add doc's accountingLines
                for (const al of doc.accountingLines) {
                    if (al.date) {
                        const mDate = moment(al.date).add(1, "day");
                        if (mDate.isAfter(mLastDate)) {
                            mLastDate = mDate;
                            lastDate = mDate.format();
                        }
                        // date = mDate.format();
                    }
                    const row = {
                        date: lastDate,
                        accountableAccount: al.accountableAccount,
                        user: al.user,
                        thirdPartyCompany: al.thirdPartyCompany,
                        bankAccount: al.bankAccount,
                        wording: al.wording,
                        debit: reversal ? al.credit : al.debit,
                        credit: reversal ? al.debit : al.credit,
                    };
                    this.prefilledRows.push(row);
                }
            }
        }
        if (!this.editionLog || differentLogs) {
            this.editionLog = "MISCELLANEOUS_OPERATION";
        } else if (!this.editionLogTagId || differentLogTagIds) {
            this.editionLogTagId = "";
        }
        this.accountingItemEditionDialog = true;
    }

    @Watch("type")
    onTypeChanged() {
        // this.$emit("validated", this.type);
        this.value = this.type;
        // if (!this.type.startsWith("BANK_TRANSACTION")) {
        //     this.setDocumentType(this.type)
        // }
    }

    getDocumentLog(doc) {
        for (const tag of doc.tags) {
            if (tag.primaryLog) {
                return tag.name;
            }
        }
        return this.$t("document.shortType." + doc.type || "UNKNOWN");
    }

    get logTagId() {
        for (const tag of this.documentTags) {
            if (tag.primaryLog) {
                return tag.id;
            }
        }
        return "";
    }

    newCommonFormatCurrency(value) {
        return newCommonFormatCurrency(value, undefined);
    }

    get allTypes() {
        return this.documentTypes;
    }

    get minDate() {
        if (this.selectedAccountingPeriod) {
            return this.selectedAccountingPeriod.start;
        }
        return null;
    }

    get maxDate() {
        if (this.selectedAccountingPeriod) {
            return this.selectedAccountingPeriod.end;
        }
        return null;
    }

    allDocumentStatus = ["VALIDATED"];

    get totalDebit() {
        let total = 0;
        for (const document of this.documents) {
            for (const al of document.accountingLines) {
                if (al.amountSigned > 0) total += al.amountSigned;
            }
        }
        return total;
    }

    get totalCredit() {
        let total = 0;
        for (const document of this.documents) {
            for (const al of document.accountingLines) {
                if (al.amountSigned < 0) total -= al.amountSigned;
            }
        }
        return total;
    }

    getAccountableAccountTitle(item) {
        let title = "";
        if (item && item.accountableAccount) {
            title = item.accountableAccount.displayName || item.accountableAccount.name;
            if (title) {
                title += " - ";
            }
            title += item.accountableAccount.description;
        }
        return title;
    }

    getThirdPartyName(item) {
        let title = "";
        if (item.thirdPartyCompany) {
            title = item.thirdPartyCompany.name;
        }
        if (item.user) {
            if (title) title += " - ";
            title += getUserDisplayName(item.user);
        }
        if (item.bankAccount) {
            if (title) title += " - ";
            title += item.bankAccount.name;
        }
        return title;
    }

    beforeMount() {
        this.onlyAccounting = true;
        this.initializeSelectedType();
        this.documentStatus = "VALIDATED";
        this.query = DOCUMENTS_FILTER_QUERY;
        this.onTypeChanged();
        this.finishMounted();
    }

    getCellStyle(index, initialStyle = "") {
        let style = initialStyle || "";

        if (index === 0) {
            style += "border-top: solid 12px #F1F1F1 !important;";
        }
        // if (transparent) {
        //     style+=  "background-color: #F1F1F1 !important; border-bottom: solid 1px #F1F1F1 !important;"
        // }
        return style;
    }

    get labelTextColor() {
        return colors.grey.darken2;
    }

    private initializeSelectedType(): void {
        if (this.canTypeBeSelected(this.value)) {
            // The type has been updated by AccountingLogPage or AccountingLogBank.
            // Thus, we update the store, by using the logic of Documents.ts.
            this.type = this.value;
        } else if (this.canTypeBeSelected(this.type)) {
            // By updating the value, the parent component knows the type
            // and it can hide the component if needed.
            this.value = this.type;
        } else {
            this.type = "ALL";
        }
    }

    private canTypeBeSelected(type: string): boolean {
        if (!type || !this.logTypes?.length) {
            return false;
        }

        for (const logType of this.logTypes) {
            if (type.startsWith(logType)) {
                return true;
            }
        }

        return false;
    }
}

export default toNative(AccountingLogDocument);
</script>
